// Libellé d'une métrique du reporting : clés curées, puis libellés existants du Reporting, sinon clé lisible
const SHORT = { facebook: 'fb', instagram: 'insta', linkedin: 'linkedin', tiktok: 'tiktok' }

export function metricLabel(vm, key, network) {
  const candidates = [`dash.overview.metrics.${key}`]
  const short = SHORT[network]
  if (short) {
    candidates.push(`dash.label.${short}.${key}`, `dash.label.${short}.${key.replace(/_graph$/, '')}`)
  }
  Object.values(SHORT).forEach(s => candidates.push(`dash.label.${s}.${key}`, `dash.label.${s}.${key.replace(/_graph$/, '')}`))
  const found = candidates.find(k => vm.$te(k))
  if (found) return vm.$t(found)
  const words = key
    .replace(/_graph$/, '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .trim()
    .toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

// Aide de la métrique : tooltip existant du Reporting si disponible
export function metricHelp(vm, key, network) {
  const short = { facebook: 'fb', instagram: 'insta', linkedin: 'linkedin', tiktok: 'tk' }[network]
  const base = key.replace(/_graph$/, '')
  const candidates = [`dash.overview.metrics_help.${key}`]
  if (short) candidates.push(`dash.reporting.graph.choice.tooltip.${base}.${short}`, `dash.reporting.graph.choice.tooltip.${key}.${short}`)
  const found = candidates.find(k => vm.$te(k))
  return found ? vm.$t(found) : ''
}
